import {
  isPricingSupersededError,
  PRICING_SUPERSEDED_MESSAGE,
  responseErrorCode,
} from "./pricing-errors"

export {
  isPricingSupersededError,
  PRICING_SUPERSEDED_CODE,
  PRICING_SUPERSEDED_MESSAGE,
} from "./pricing-errors"

export const BATTERY_SYSTEM_PRICING_REQUIRED_CODE = `BATTERY_SYSTEM_PRICING_REQUIRED`

export const isBatterySystemPricingRequiredError = (error: unknown): boolean =>
  responseErrorCode(error) === BATTERY_SYSTEM_PRICING_REQUIRED_CODE

/** Pricing: PowurOS priced the proposal without its saved AI compute node, so nothing was stored. */
export const BATTERY_COMPUTE_NOT_PRICED_CODE = `BATTERY_COMPUTE_NOT_PRICED`

export const BATTERY_COMPUTE_NOT_PRICED_MESSAGE = `PowurOS priced this proposal without its AI compute node, so the price was not saved. Remove the node in AI Compute to price the battery alone, or try again once PowurOS prices compute nodes for Battery-Only Proposals.`

export const isBatteryComputeNotPricedError = (error: unknown): boolean =>
  responseErrorCode(error) === BATTERY_COMPUTE_NOT_PRICED_CODE

/** What a Battery pricing command's failure says: its own reason, or the caller's prompt. */
export const describeBatteryPricingError = (
  error: unknown,
  fallback: string,
): string =>
  isPricingSupersededError(error)
    ? PRICING_SUPERSEDED_MESSAGE
    : isBatteryComputeNotPricedError(error)
      ? BATTERY_COMPUTE_NOT_PRICED_MESSAGE
      : fallback
